import {
    Checkbox,
    Collapse,
    FormControlLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    MenuItem,
    TextField,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { inputColor, inputVariant } from "../../../../settings/inputConfig";

import CloseIcon from "@material-ui/icons/Close";
import { DateTimePicker } from "@material-ui/pickers";
import { EnumTipoBusquedaFolio, EnumIdiomas } from "../../../../settings/enumConfig";
import { Fragment } from "react";
import MeditocDateIcon from "../../../utils/MeditocDateIcon";
import MeditocInputPhone from "../../../utils/MeditocInputPhone";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocSubtitulo from "../../../utils/MeditocSubtitulo";
import SearchIcon from "@material-ui/icons/Search";
import { useAdminConsulta } from "../../../../context/AdminConsultaContext";

export default function FormConsulta() {
    const {
        consultaSeleccionada,
        modalOpenFormConsulta,
        formConsulta,
        folioValidado,
        folioUsuarioEncontrado,
        handleOpenFormConsulta,
        handleChangeFolioValidado,
        handleChangeFormConsultaText,
        handleChangeFormConsultaDate,
        handleChangeFormConsultaDateInicio,
        handleChangeFormConsultaCheck,
        handleClickLimpiarFolio,
        handleClickValidarFolio,
        handleSubmitFormConsulta,
    } = useAdminConsulta();

    const {
        txtFolioConsulta,
        txtNombrePaciente,
        txtTelefonoPaciente,
        txtCorreoPaciente,
        txtFechaProgramadaInicio,
        txtFechaProgramadaFin,
        slcIdioma,
        chkFolio,
        txtTipoBusqueda,
    } = formConsulta;

    return (
        <MeditocModal
            title={consultaSeleccionada.iIdConsulta === 0 ? "Nueva consulta" : "Editar consulta"}
            size="small"
            open={modalOpenFormConsulta}
            setopen={handleOpenFormConsulta}
            okmessage="GUARDAR CONSULTA"
            okfunc={handleSubmitFormConsulta}
            okDisabled={chkFolio.value && !folioValidado && consultaSeleccionada.iIdConsulta === 0}
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormControlLabel
                        label={chkFolio.message}
                        control={
                            <Checkbox
                                name="chkFolio"
                                checked={chkFolio.value}
                                disabled={consultaSeleccionada.iIdConsulta !== 0}
                                onChange={(e) => handleChangeFormConsultaCheck(e, "chkFolio")}
                            />
                        }
                    />
                </Grid>
                {consultaSeleccionada.iIdConsulta === 0 && (
                    <Grid item xs={12}>
                        <Collapse in={chkFolio.value}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography>{txtTipoBusqueda.label}</Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <RadioGroup
                                        row
                                        name="txtTipoBusqueda"
                                        value={txtTipoBusqueda.value}
                                        onChange={(e) => {
                                            handleChangeFormConsultaText(e);
                                            handleChangeFolioValidado(false);
                                        }}
                                    >
                                        <FormControlLabel
                                            control={<Radio />}
                                            label="Por folio"
                                            value={EnumTipoBusquedaFolio.folio}
                                            disabled={consultaSeleccionada.iIdConsulta !== 0}
                                        />
                                        <FormControlLabel
                                            control={<Radio />}
                                            label="Por correo electrónico del usuario"
                                            value={EnumTipoBusquedaFolio.usuario}
                                            disabled={consultaSeleccionada.iIdConsulta !== 0}
                                        />
                                    </RadioGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <MeditocSubtitulo
                                        title={
                                            txtTipoBusqueda.value === EnumTipoBusquedaFolio.folio
                                                ? "Folio del paciente"
                                                : "Correo electrónico de usuario Meditoc"
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name="txtFolioConsulta"
                                        label={
                                            txtTipoBusqueda.value === EnumTipoBusquedaFolio.folio
                                                ? txtFolioConsulta.label
                                                : txtFolioConsulta.label2
                                        }
                                        required={txtFolioConsulta.required}
                                        value={txtFolioConsulta.value}
                                        error={txtFolioConsulta.error}
                                        helperText={txtFolioConsulta.error && txtFolioConsulta.message}
                                        onChange={(e) => {
                                            handleChangeFormConsultaText(e);
                                            handleChangeFolioValidado(false);
                                        }}
                                        fullWidth
                                        color={inputColor}
                                        variant={inputVariant}
                                        disabled={consultaSeleccionada.iIdConsulta !== 0}
                                        InputProps={{
                                            endAdornment: consultaSeleccionada.iIdConsulta === 0 && (
                                                <Fragment>
                                                    <Tooltip
                                                        title={
                                                            txtTipoBusqueda.value === EnumTipoBusquedaFolio.folio
                                                                ? "Buscar folio"
                                                                : "Buscar correo electrónico"
                                                        }
                                                        arrow
                                                        placement="top"
                                                    >
                                                        <IconButton onClick={handleClickValidarFolio}>
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip
                                                        title={
                                                            txtTipoBusqueda.value === EnumTipoBusquedaFolio.folio
                                                                ? "Quitar folio"
                                                                : "Quitar correo electrónico"
                                                        }
                                                        arrow
                                                        placement="top"
                                                    >
                                                        <IconButton onClick={handleClickLimpiarFolio}>
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Fragment>
                                            ),
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Collapse>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <Collapse in={!chkFolio.value || folioValidado || consultaSeleccionada.iIdConsulta !== 0}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <MeditocSubtitulo title="Datos del paciente" />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    name="txtNombrePaciente"
                                    label={txtNombrePaciente.label}
                                    required={txtNombrePaciente.required}
                                    value={txtNombrePaciente.value}
                                    error={txtNombrePaciente.error}
                                    helperText={txtNombrePaciente.error && txtNombrePaciente.message}
                                    onChange={handleChangeFormConsultaText}
                                    variant={inputVariant}
                                    color={inputColor}
                                    fullWidth
                                    disabled={consultaSeleccionada.iIdConsulta !== 0}
                                />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <TextField
                                    name="txtTelefonoPaciente"
                                    label={txtTelefonoPaciente.label}
                                    required={txtTelefonoPaciente.required}
                                    value={txtTelefonoPaciente.value}
                                    error={txtTelefonoPaciente.error}
                                    helperText={txtTelefonoPaciente.error && txtTelefonoPaciente.message}
                                    onChange={handleChangeFormConsultaText}
                                    variant={inputVariant}
                                    color={inputColor}
                                    fullWidth
                                    disabled={consultaSeleccionada.iIdConsulta !== 0}
                                    InputProps={{ inputComponent: MeditocInputPhone }}
                                />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <TextField
                                    name="txtCorreoPaciente"
                                    label={txtCorreoPaciente.label}
                                    required={txtCorreoPaciente.required}
                                    value={txtCorreoPaciente.value}
                                    error={txtCorreoPaciente.error}
                                    helperText={txtCorreoPaciente.error && txtCorreoPaciente.message}
                                    onChange={handleChangeFormConsultaText}
                                    variant={inputVariant}
                                    color={inputColor}
                                    fullWidth
                                    disabled={consultaSeleccionada.iIdConsulta !== 0}
                                />
                            </Grid>
                            {folioUsuarioEncontrado && folioUsuarioEncontrado.iConsultaPsicologica && (
                                <Grid
                                    item
                                    xs={12}
                                    className={
                                        folioUsuarioEncontrado.iConsultaPsicologica ===
                                        folioUsuarioEncontrado.iConsultaPsicologicaConteo
                                            ? "color-5"
                                            : "color-3"
                                    }
                                >
                                    <Typography>
                                        Consultas de la membresía o plan Psicólogo:{" "}
                                        {folioUsuarioEncontrado.iConsultaPsicologica}
                                    </Typography>
                                    <Typography>
                                        Consultas disponibles:{" "}
                                        {folioUsuarioEncontrado.iConsultaPsicologica -
                                            folioUsuarioEncontrado.iConsultaPsicologicaConteo}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>
                    </Collapse>
                </Grid>
                <Grid item xs={12}>
                    <MeditocSubtitulo title="Horario de consulta" />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <DateTimePicker
                        name="txtFechaProgramadaInicio"
                        label={txtFechaProgramadaInicio.label}
                        required={txtFechaProgramadaInicio.required}
                        value={txtFechaProgramadaInicio.value}
                        error={txtFechaProgramadaInicio.error}
                        helperText={txtFechaProgramadaInicio.error && txtFechaProgramadaInicio.message}
                        onChange={(date) => handleChangeFormConsultaDateInicio(date)}
                        InputProps={{ endAdornment: <MeditocDateIcon /> }}
                        format="dd/MM/yyyy hh:mm a"
                        inputVariant={inputVariant}
                        color={inputColor}
                        variant="inline"
                        disablePast
                        fullWidth
                        autoOk={true}
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <DateTimePicker
                        name="txtFechaProgramadaFin"
                        label={txtFechaProgramadaFin.label}
                        required={txtFechaProgramadaFin.required}
                        value={txtFechaProgramadaFin.value}
                        error={txtFechaProgramadaFin.error}
                        helperText={txtFechaProgramadaFin.error && txtFechaProgramadaFin.message}
                        onChange={(date) => handleChangeFormConsultaDate(date)}
                        InputProps={{ endAdornment: <MeditocDateIcon /> }}
                        format="dd/MM/yyyy hh:mm a"
                        inputVariant={inputVariant}
                        color={inputColor}
                        variant="inline"
                        disablePast
                        fullWidth
                        autoOk={true}
                    />
                </Grid>
                <Grid item sm={12} xs={12}>
                    <TextField
                        name="slcIdioma"
                        label={slcIdioma.label}
                        required={slcIdioma.required}
                        value={slcIdioma.value}
                        error={slcIdioma.error}
                        helperText={slcIdioma.error && slcIdioma.message}
                        onChange={handleChangeFormConsultaText}
                        variant={inputVariant}
                        color={inputColor}
                        fullWidth
                        select
                    >
                        {Object.keys(EnumIdiomas).map((EnumKey) => (
                            <MenuItem key={EnumKey} value={EnumKey}>
                                {EnumIdiomas[EnumKey]}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
